// client/src/services/NotificationContext.js

import React, { createContext, useContext, useEffect, useState } from 'react';
import { notificationService } from './NotificationService';

const NotificationContext = createContext(null);

export const NotificationProvider = ({ children }) => {
  const [isInitialized, setIsInitialized] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const initializeNotifications = async () => {
      try {
        await notificationService.initialize();
        setIsInitialized(true);
        setError(null);
      } catch (err) {
        setError(err.message);
        setIsInitialized(false);
      }
    };

    initializeNotifications();
  }, []);

  return (
    <NotificationContext.Provider 
      value={{ 
        notificationService, 
        isInitialized,
        error,
        hasPermission: notificationService.hasPermission 
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};

export const useNotifications = () => {
  const context = useContext(NotificationContext);
  if (!context) {
    throw new Error('useNotifications must be used within a NotificationProvider');
  }
  return context;
};